import { useState, useEffect } from 'react';

// Phone < 640px, tablet 640–1024px, desktop > 1024px.
// Keep these in sync with the media queries in responsive.css, where phone is
// max-width 639.98px and phone + tablet together are max-width 1024px.
// getBreakpoint() checks phone first, so the tablet query can start at the same
// 639.98px edge and leave no gap for fractional widths (zoom / high-DPI).
export const PHONE_QUERY  = '(max-width: 639.98px)';
export const TABLET_QUERY = '(min-width: 639.98px) and (max-width: 1024px)';

const hasMatchMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

const getBreakpoint = () => {
  if (!hasMatchMedia()) return 'desktop';
  if (window.matchMedia(PHONE_QUERY).matches)  return 'phone';
  if (window.matchMedia(TABLET_QUERY).matches) return 'tablet';
  return 'desktop';
};

// True when the primary input can hover (mouse / trackpad).
export const canHover = () => hasMatchMedia() && window.matchMedia('(hover: hover)').matches;

// True on touch-first devices (phones, tablets).
export const isTouchDevice = () => hasMatchMedia() && window.matchMedia('(hover: none) and (pointer: coarse)').matches;

// Returns 'phone' | 'tablet' | 'desktop' and updates when the viewport crosses a breakpoint.
export default function useBreakpoint() {
  const [bp, setBp] = useState(getBreakpoint);

  useEffect(() => {
    if (!hasMatchMedia()) return undefined;
    const lists = [window.matchMedia(PHONE_QUERY), window.matchMedia(TABLET_QUERY)];
    const update = () => setBp(getBreakpoint());
    lists.forEach(l => (l.addEventListener ? l.addEventListener('change', update) : l.addListener(update)));
    update();
    return () => lists.forEach(l => (l.removeEventListener ? l.removeEventListener('change', update) : l.removeListener(update)));
  }, []);

  return bp;
}
